// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__8hdy0","invalid":"Input_invalid__otMIx"};